<div class="opacity-50">
  <span>{{ usedChars }}</span
  >/{{ totalChars }} char.
</div>
